const NO_PRINT_DATA_ATTRIBUTE = 'printty-no-print';
const NO_PRINT_DATA_SET = 'printtyNoPrint';
const PRINT_FRAME_ID = 'printFrame';
/** The identifier of the root element of the print frame, the first element placed within the body of the print frame */
const PRINT_FRAME_ROOT_ID = 'printty-root';

const PRINT_FRAME_HEADER_ID = 'printty-frame-header';

/**
 * The identifier of the element that is being printed
 * This can be used to target the element(s) in the iframe
 * This is useful when you have multiple elements that need to be printed
 * and want to provide spacing between the pages to prevent them from running into the margins
 */
const PRINTTY_ELEMENT_CLASS_ID = 'printty-element';

export {
  NO_PRINT_DATA_ATTRIBUTE,
  NO_PRINT_DATA_SET,
  PRINT_FRAME_HEADER_ID,
  PRINT_FRAME_ID,
  PRINT_FRAME_ROOT_ID,
  PRINTTY_ELEMENT_CLASS_ID,
};
